import React, { useState, useEffect } from 'react';
import {
    Box,
    Container,
    Typography,
    Grid,
} from '@mui/material'
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import frameVideo from '../../assets/images/frame.mp4';
import clLogo from '../../assets/images/cl-logo.png';
import homeImage from '../../assets/videos/home_image02.mp4';
import homeImage02 from '../../assets/home_image2.svg';
import homeImage03 from '../../assets/home_image3.svg';
import { getSearchStats } from '../../services/searchService';

const Faq = () => {
    const a = '{a} ';
    
    return (
        <Box sx={{ bgcolor: '#000', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Header />
        
            <Container maxWidth="xl" sx={{ mt: 8, mb: 20}}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'left', textAlign: 'left' }}>
                    <Typography variant="h4" align="center" sx={{ color: '#FFF', fontWeight: 700, fontSize: { xs: '2.2rem', md: '2.94rem' }, mb: 5, mt: 5}}>
                        Frequently Asked Questions (FAQs)
                    </Typography>

                    <Typography variant="h4" align="left" color='#FFF' mb={2} mt={1}>What is Getlista?</Typography>
                    <Typography variant="subtitle1" align="left" color='#FFF' mb={1}>
                        getlista.io is a computer program designed to search the open web for public data related to individuals' professional journeys and accomplishments. On request by the user, the program processes this information searched to generate insightful data and utilizes third-party services to curate contact information
                    </Typography>

                    <Typography variant="h4" align="left" color='#FFF' mb={2} mt={1}>
                        What does getlista.io mean by openweb?
                    </Typography>
                    <Typography variant="subtitle1" align="left" color='#FFF' mb={1}>
                        The term "open web" generally refers to the publicly accessible and non-proprietary portion of the internet, which includes websites and online content that can be freely accessed by anyone without restrictions. It encompasses information that is voluntarily shared by individuals or organizations on publicly available websites.
                    </Typography>

                    <Typography variant="h4" align="left" color='#FFF' mb={2} mt={1}>
                        Do I need anything special to use it?
                    </Typography>
                    <Typography variant="subtitle1" align="left" color='#FFF' mb={1}>
                        <ul>
                            <li>
                                Internet Access: Ensure that you have a stable and reliable internet connection as the tool likely operates online to fetch and process data from the web.
                            </li>
                            <li>
                                Supported Devices: Verify if the service is compatible with the devices you intend to use (e.g., desktop, laptop, mobile).
                            </li>
                            <li>
                                Browser Compatibility: Some tools may have specific browser requirements. Check if there are any recommendations for browsers that work best with the tool.
                            </li>
                            <li>
                                User Account: Depending on the features and functionalities of getlista.io, you may need to create a user account on the platform. Be sure to understand the terms of service and privacy policy associated with creating an account.
                            </li>
                            <li>
                                Permissions: getlista.io have automated the login process using email, linkedin.com, gmail.com. lista.io will require your permission to know your first name, last name and email id to grant you access to use the service. 
                            </li>
                        </ul>
                    </Typography>

                    <Typography variant="h4" align="left" color='#FFF' mb={2} mt={1}>
                        What all permission does lista.io saves while using login credentials?
                    </Typography>
                    <Typography variant="subtitle1" align="left" color='#FFF' mb={1}>
                        To deliver a personalized experience and ensure sufficient support, it is essential for the platform to verify the legitimacy of the user and ascertain that it is not an automated bot or malicious software. As a security measure and to safeguard the privacy of our customers, lista.io, during the login process, retains specific information such as user images, full names, email addresses, and login dates. 
                    </Typography>

                    <Typography variant="h4" align="left" color='#FFF' mb={2} mt={1}>
                        How to use it?
                    </Typography>
                    <Typography variant="subtitle1" align="left" color='#FFF' mb={1}>
                        <ul>
                            <li>
                                Visit the Official Website:
                                <ul>
                                    <li>
                                        Go to the official website of getlista.io. This is where you can find detailed information about the tool, including its features and usage instructions.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Sign in with Auto Workflow or Create an Account:
                                <ul>
                                    <li>
                                        To access getlista.io, use the automated workflow for a secure login process via linkedin.com, gmail.com, Microsoft Office, or through email OTP verification.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Explore Search Features:
                                <ul>
                                    <li>
                                        Once logged in, utilize the search tab to find and connect with individuals you are looking for.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Find Contact Details:
                                <ul>
                                    <li>
                                        Click on the person's profile in List{a} to generate insights. Click "Reveal Contact" to unveil contact details such as email or phone numbers through third-party affiliations.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Create Custom Lists:
                                <ul>
                                    <li>
                                        Add prospects to your personalized lists where you can define tags and categorize individuals based on your preferences.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Contact Support (if needed):
                                <ul>
                                    <li>
                                    If you encounter any issues or have specific questions about using getlista.io, contact the support team for assistance. Use the messenger icon located at the bottom right corner of the page or send an email to gg@getlista.io.
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </Typography>

                    <Typography variant="h4" align="left" color='#FFF' mb={2} mt={1}>
                        How can I send updates to Getlista?
                    </Typography>
                    <Typography variant="subtitle1" align="left" color='#FFF' mb={1}>
                        If you encounter any issues or have specific questions about using getlista.io, contact the support team for assistance. Use the messenger icon located at the bottom right corner of the page or send an email to gg@getlista.io.
                    </Typography>

                    <Typography variant="h4" align="left" color='#FFF' mb={2} mt={1}>
                        What's a Post or comment?
                    </Typography>
                    <Typography variant="subtitle1" align="left" color='#FFF' mb={1}>
                        Post or comment refers to user individual notes to identify a prospect in user’s language. The comments can be edited n number of times by user as per his/her choice.
                    </Typography>

                    <Typography variant="h2" align="left" color='#FFF' mb={2} mt={1}>
                        Direct Messages:
                    </Typography>
                    <Typography variant="h4" align="left" color='#FFF' mb={2} mt={1}>
                        Can a user send Direct Messages to the other user?
                    </Typography>
                    <Typography variant="subtitle1" align="left" color='#FFF' mb={1}>
                        Thank you for your inquiry. At the moment, our platform does not support direct messaging between users. We appreciate your understanding and are here to assist with any other questions or concerns you may have within the platform's current functionalities.
                    </Typography>

                    <Typography variant="h2" align="left" color='#FFF' mb={2} mt={1}>
                        Getlista policies and reporting:
                    </Typography>
                    <Typography variant="h4" align="left" color='#FFF' mb={2} mt={1}>
                        Why are accounts suspended?
                    </Typography>
                    <Typography variant="subtitle1" align="left" color='#FFF' mb={1}>
                        Accounts are suspended for the violations of Terms and Conditions or spam investigation. Read more about account suspension.
                    </Typography>


                    <Typography variant="h4" align="left" color='#FFF' mb={2} mt={1}>
                        Where can I find out more information about Getlista's Terms of Service or Privacy Policy?
                    </Typography>
                    <Typography variant="subtitle1" align="left" color='#FFF' mb={1}>
                        Visit the official website of Getlista. Typically, the Terms of Service and Privacy Policy can be found in the footer of the website. 
                    </Typography>

                    <Typography variant="h4" align="left" color='#FFF' mb={2} mt={1}>
                        How do I submit a complaint about copyright, impersonation, trademark, or other violation of Terms and Conditions/Privacy Policy issues?
                    </Typography>
                    <Typography variant="subtitle1" align="left" color='#FFF' mb={1}>
                        If you encounter any issues or have specific questions about using getlista.io, contact the support team for assistance. Use the messenger icon located at the bottom right corner of the page or send an email to gg@getlista.io.
                    </Typography>

                    <Typography variant="h4" align="left" color='#FFF' mb={2} mt={1}>
                        What is a subscription? 
                    </Typography>
                    <Typography variant="subtitle1" align="left" color='#FFF' mb={1}>
                        For a user to use features like list, adding tags on https://getlista.io  a user is required to buy a subscription by choosing a monthly subscription or one-time annual subscription as per the cost shared under the pricing section on https://getlista.io . By default first-time users will get 10-day free trial with 10 complimentary credits.
                    </Typography>

                    <Typography variant="h4" align="left" color='#FFF' mb={2} mt={1}>
                        What are credits?
                    </Typography>
                    <Typography variant="subtitle1" align="left" color='#FFF' mb={1}>
                        To view a contact number or email address, the user is required to top up credits where a user can buy credits at any point in time as per his/her needs. A user can buy credits from pricing page or from your dashboard once you are logged in on https://getlista.io.
                    </Typography>

                    <Typography variant="h4" align="left" color='#FFF' mb={2} mt={1}>
                        What if my subscription is active but I don’t have credits?
                    </Typography>
                    <Typography variant="subtitle1" align="left" color='#FFF' mb={1}>
                        If you subscription is active but don’t have credits you will not be able to view contact number or email id though you will be able to search, use lists, tags etc.
                    </Typography>

                    <Typography variant="h4" align="left" color='#FFF' mb={2} mt={1}>
                        What If I have credits but my subscription is over?
                    </Typography>
                    <Typography variant="subtitle1" align="left" color='#FFF' mb={1}>
                        You will be required to renew subscription for you to use the platform.
                    </Typography>

                </Box>
            </Container>
            <Footer />
        </Box>
    );
};
export default Faq;